// extracted by mini-css-extract-plugin
export default {"initial-row":"address-info_initial-row__2L9IS","row":"address-info_row__pfMNa"};